const UNIT_FACTOR = 1024;

enum EVolumeUnit {
  MegaByte,
  GigaByte,
}

const getKiloBytes = (volumeUnit: EVolumeUnit) => {
  if (volumeUnit === EVolumeUnit.MegaByte) {
    return UNIT_FACTOR;
  }
  return UNIT_FACTOR * getKiloBytes(EVolumeUnit.MegaByte);
};

const getVolumeUnit = (volume: number) => {
  if (volume < getKiloBytes(EVolumeUnit.GigaByte)) {
    return EVolumeUnit.MegaByte;
  }
  return EVolumeUnit.GigaByte;
};

export const getVolumeInitials = (volume: number) => {
  const volumeUnit = getVolumeUnit(volume);
  if (volumeUnit === EVolumeUnit.MegaByte) {
    return 'MB';
  }
  return 'GB';
};

export const formatVolumeInGB = (volume: number): number => {
  return volume / UNIT_FACTOR;
};

export const formatVolumeWithoutInitials = (volume: number): number => {
  if (Math.abs(volume) < UNIT_FACTOR) {
    return volume;
  }

  const r = 10;

  do {
    volume /= UNIT_FACTOR;
  } while (Math.round(Math.abs(volume) * r) / r >= UNIT_FACTOR);

  return parseFloat(volume.toFixed(1));
};

export const formatVolume = (volume: number): string => {
  const volumeInitials = getVolumeInitials(volume);

  if (Math.abs(volume) < UNIT_FACTOR) {
    return volume + volumeInitials;
  }

  const r = 10;

  do {
    volume /= UNIT_FACTOR;
  } while (Math.round(Math.abs(volume) * r) / r >= UNIT_FACTOR);

  const fixed = volume.toFixed(1);

  return (fixed.endsWith('.0') ? fixed.slice(0, -2) : fixed) + volumeInitials;
};
